export function DashboardUnavailable({ firstName }: { firstName: string }) {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-foreground">
        Welcome back, {firstName}.
      </h1>
    </div>
  );
}
